import React from 'react'

import LoadingIcon from "./LoadingIcon";
import FacebookFriendList from "./FacebookFriendList";
import {Button} from "@material-ui/core";
import {
  arePermissionsGranted,
  FacebookAccessTokenGetter,
  FacebookLogin,
  FacebookLogout,
  FacebookPermissionGetter
} from "../Helpers/facebook";
import {
  FACEBOOK_APP_ID,
  IS_FACEBOOK_FRIENDS_ENABLED,
  FACEBOOK_LOGIN_BUTTON_IMAGE_URL,
  FACEBOOK_LOGOUT_BUTTON_IMAGE_URL
} from "../Helpers/constants"
import {
  canPostMessageToMobile,
  isAndroid,
  isIOS, isWindows,
  Message, postMessageToIOS,
  postMessageToMobile, postMessageToWindows
} from "../Helpers/clientCommunication";
import {compareVersions} from "../Helpers/version";
import {buildInviteUrl, SocialInvite} from "../Helpers/invites";


class InviteFromFacebook extends React.Component {

  isFacebookSDKLoaded = false
  accessToken = ""

  constructor(props) {
    super(props)

    this.state = {
      facebookFriends: [],
      isFacebookLoggedIn: false,
      isUserFriendsPermissionGranted: false,
      isFacebookFinishedLoading: false, // Used to determine if we are finished fetching data from Facebook
    }

    console.log("constructor: isFacebookFriendsEnabled=[" + IS_FACEBOOK_FRIENDS_ENABLED + "], " +
      "facebookAppID=[" + FACEBOOK_APP_ID + "]")
  }

  runIfFacebookSDKIsLoaded() {
    if (!this.isFacebookSDKLoaded && typeof FB === "undefined") {
      console.log("runIfFacebookSDKIsLoaded: Facebook SDK NOT loaded")
      return
    }
    console.log("runIfFacebookSDKIsLoaded: Facebook SDK IS loaded")

    const device = window.queryParams.device
    const version = window.queryParams.version
    if (isAndroid(device) && (!version || compareVersions(version, "5.0.7") < 0)) {
      // Facebook Friends is not available on Cook'n Android 5.0.6 and earlier due to Facebook not allowing login via
      // Android WebView
      this.setIsFacebookFinishedLoading(true)
      return
    }

    new FacebookAccessTokenGetter((accessToken) => {
      // Cache the accessToken
      this.accessToken = accessToken

      const isLoggedIn = accessToken !== null
      this.setState((state, props) => ({
        isFacebookLoggedIn: isLoggedIn
      }))

      if (isLoggedIn) {
        this.fetchFacebookFriends()
      } else {
        this.setIsFacebookFinishedLoading(true)
      }
    }).get()
  }

  loginFacebook = () => {
    this.setIsFacebookFinishedLoading(false)

    new FacebookLogin((accessToken) => {
      if (accessToken !== null) {
        // User successfully logged in with Facebook
        console.log("loginFacebook: Successfully logged in")

        // Cache accessToken
        this.accessToken = accessToken

        // Show Logout button
        this.setState((state, props) => ({
          isFacebookLoggedIn: true
        }))

        // Get the user's Facebook Friends
        this.fetchFacebookFriends()
      } else {
        // User failed to login with Facebook
        console.log("loginFacebook: Failed to log in")
        this.setIsFacebookFinishedLoading(true)
      }
    }).login()
  }

  logoutFacebook = () => {
    new FacebookLogout(() => {
      console.log("logoutFacebook: Successfully logged out")

      // Un-cahce accessToken
      this.accessToken = ''

      this.setState((state, props) => ({
        facebookFriends: [],
        isFacebookLoggedIn: false,
        isUserFriendsPermissionGranted: false
      }))
    }).logout()
  }

  postFacebookInvite = () => {
    console.log("postFacebookInvite")
    const invite = SocialInvite.initEmpty()
    invite.inviterAccountId = this.props.aid
    const inviteUrl = buildInviteUrl(invite, "facebook-friend-invite-post")
    console.debug("postFacebookInvite: inviteUrl=[" + inviteUrl + "]")
    const device = window.queryParams.device
    const version = window.queryParams.version
    if (isAndroid(device)) {
      // Tell Android to open the share dialog
      if (canPostMessageToMobile(device, version)) {
        const message = new Message(Message.ACTION_DO_FACEBOOK_INVITE_POST, {
          inviteUrl: inviteUrl
        })
        postMessageToMobile(device, version, message)
      } else {
        // This shouldn't happen
      }
    } else if (isIOS(device)) {
      // Use the default iframe share dialog on iOS because it opens a modal UIViewController and looks nice
      window.FB.ui({
        method: 'share',
        href: inviteUrl
      }, function (response) {
        console.log("FB.ui share response: [" + JSON.stringify(response) + "]")
      })

      // Notify iOS that the share dialog was opened
      const message = new Message(Message.ACTION_DID_OPEN_FACEBOOK_SHARE_DIALOG, null)
      postMessageToIOS(message)
    } else if (isWindows(device)) {
      // Tell Windows to open a share dialog
      const message = new Message(Message.ACTION_DO_FACEBOOK_INVITE_POST, {
        inviteUrl: inviteUrl
      })
      postMessageToWindows(message)
    } else {
      // Use popup for web because screen positioning of the default iframe share dialog is messed up
      window.FB.ui({
        method: 'share',
        href: inviteUrl,
        display: 'popup'
      }, function (response) {
        console.log("FB.ui share response: [" + JSON.stringify(response) + "]")
      })
    }
  }

  fetchFacebookFriends() {
    arePermissionsGranted((granted) => {
      this.setState((state, props) => ({
        isUserFriendsPermissionGranted: granted
      }))

      if (granted) {
        window.FB.api('/me', response => {
          const userId = response.id
          const name = response.name
          console.log("fetchFacebookFriends: FB.api /me response: " +
            "userId=[" + userId + "], name=[" + name + "]")

          // Check to make sure this Facebook ID is attached to the current Cook'n user

          // Next, fetch the Facebook user's friends
          window.FB.api('/' + userId + '/friends', result => {
            if (result && !result.error) {
              console.log("fetchFacebookFriends: FB.api /friends api success response: " +
                "data=[" + JSON.stringify(result.data) + "]")

              this.setState((state, props) => ({
                facebookFriends: result.data
              }))
            } else {
              console.log("fetchFacebookFriends: FB.api /friends api error response: " +
                "[" + JSON.stringify(result.error) + "]")
            }
            this.setIsFacebookFinishedLoading(true)
          }, { access_token: this.accessToken })
        }, { access_token: this.accessToken })
      } else {
        this.setIsFacebookFinishedLoading(true)
      }
    }, this.accessToken, ["user_friends"])
  }

  requestUserFriendsPermission = () => {
    console.log("requestUserFriendsPermission")
    this.setIsFacebookFinishedLoading(false)

    new FacebookPermissionGetter((granted) => {
      this.setState((state, props) => ({
        isUserFriendsPermissionGranted: granted
      }))

      if (granted) {
        this.fetchFacebookFriends()
      } else {
        this.setIsFacebookFinishedLoading(true)
      }
    }, this.accessToken, ["user_friends"]).get()
  }

  setIsFacebookFinishedLoading(isFinished) {
    this.setState((state, props) => ({
      isFacebookFinishedLoading: isFinished
    }))
  }

  componentDidMount() {
    if (!IS_FACEBOOK_FRIENDS_ENABLED) {
      this.setIsFacebookFinishedLoading(true)
    } else {
      ;(function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) {
          return
        }
        js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/en_US/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
      })(document, 'script', 'facebook-jssdk')

      console.log("componentDidMount")

      window.fbAsyncInit = () => {
        window.FB.init({
          appId: FACEBOOK_APP_ID,
          autoLogAppEvents: true,
          cookie: true,
          xfbml: true,
          version: 'v7.0',
        })

        console.log("componentDidMount: FB.init finished")
        this.isFacebookSDKLoaded = true
        this.runIfFacebookSDKIsLoaded()
      }

      this.runIfFacebookSDKIsLoaded()
    }
  }

  render() {
    return (
      <div className={"text-center"}>
        <h2>Invite Your Facebook Friends</h2>
        <p>
          This feature allows you to connect with your Facebook Friends.
          <br/>
          Simply login with Facebook and then click&nbsp;"Add +" next to those you wish to invite.
        </p>
        {this.FacebookContent()}
      </div>
    )
  }

  FacebookContent() {
    let facebookContent = ''
    if (!this.state.isFacebookFinishedLoading) {
      facebookContent = (<LoadingIcon/>)
    } else if (!IS_FACEBOOK_FRIENDS_ENABLED) {
      facebookContent = (
        <div>
          {this.ComingSoon()}
        </div>
      )
    } else {
      const device = window.queryParams.device
      const version = window.queryParams.version // If not provided by client, this is false
      console.log("FacebookContent: device=[" + device + "], version=[" + version + "]")
      if (isAndroid(device) && (!version || compareVersions(version, "5.0.7") < 0)) {
        // We're on a version of Cook'n Android which doesn't have Facebook Friends Support
        facebookContent = (
          <p style={{marginTop: "40px"}}>
            Please update Cook'n to version 5.0.7 or later to use this feature.
          </p>
        )
      } else {
        facebookContent = (
          <div>
            {this.FacebookButton()}
            {this.FacebookFriendList()}
            {this.FacebookInviteOther()}
          </div>
        )
      }
    }
    return facebookContent
  }

  FacebookInviteOther() {
    let inviteOther = ''
    // Hide this if on Android 5.0.8 or earlier
    const device = window.queryParams.device
    const version = window.queryParams.version
    const isIncompatibleAndroid = (isAndroid(device) && compareVersions(version, "5.0.9") < 0)
    if (this.state.isFacebookLoggedIn && !isIncompatibleAndroid) {
      inviteOther = (
        <div style={{marginTop: "40px"}}>
          <h3 className="large text-center">
            Looking for someone not listed above?
          </h3>
          <p>Post an invite on your Facebook page or send an invite to a specific friend.</p>
          {this.FacebookPostButton()}
        </div>
      )
    }
    return inviteOther
  }

  FacebookPostButton() {
    return (
        <Button onClick={this.postFacebookInvite}
                variant={"contained"}
                color={"primary"}
                style={{
                  display: "table",
                  margin: "0 auto",
                  marginBottom: "20px",
                  width: "250px",
                  textTransform: "none",
                  color: "white"
                }}>
          Post Invite on Facebook
        </Button>
    )
  }

  FacebookFriendList() {
    let facebookFriendsList = ''

    let isFacebookLoggedIn = this.state.isFacebookLoggedIn
    let facebookFriends = this.state.facebookFriends
    let isUserFriendsPermissionGranted = this.state.isUserFriendsPermissionGranted

    if (!isFacebookLoggedIn) {
      facebookFriendsList = null
    } else if (isFacebookLoggedIn && !isUserFriendsPermissionGranted) {
      facebookFriendsList = (
        <p>Please grant Cook'n permission to see your Facebook Friends</p>
      )
    } else {
      if (facebookFriends === undefined || facebookFriends.length === 0) {
        // User is logged into Facebook, but we got no Friends from Facebook
        let msg = "It looks like none of your Facebook Friends have Cook'n yet. "
            + "You can still invite them using the button below."
        const device = window.queryParams.device
        const version = window.queryParams.version
        const isIncompatibleAndroid = (isAndroid(device) && compareVersions(version, "5.0.9") < 0)
        if (isIncompatibleAndroid) {
          msg = "It looks like none of your Facebook Friends have Cook'n yet. "
              + "You can still invite them via email on the previous page."
        }
        facebookFriendsList = (
          <p>{msg}</p>
        )
      } else {
        // // User is logged into Facebook and we have Friends
        facebookFriendsList = (
          <FacebookFriendList
            aid={this.props.aid}
            sessionId={this.props.sessionId}
            friends={facebookFriends}
            sendInternalInvite={this.props.sendInternalInvite}/>
        )
      }
    }
    return facebookFriendsList
  }

  FacebookButton() {
    const buttonWidth = "250px"
    const bottomMargin = "10px"
    let facebookButton = ''
    if (this.state.isFacebookLoggedIn && this.state.isUserFriendsPermissionGranted) {
      // User is logged in and we have user_friends permission, this should be a logout button
      facebookButton = (
        <input type={"image"}
               src={FACEBOOK_LOGOUT_BUTTON_IMAGE_URL}
               style={{width: buttonWidth, cursor: "pointer", marginBottom: bottomMargin}}
               onClick={this.logoutFacebook}/>
      )
    } else if (this.state.isFacebookLoggedIn && !this.state.isUserFriendsPermissionGranted) {
      // User is logged in but we don't have user_friends permission, this should be a permission request button
      facebookButton = (
        <Button onClick={this.requestUserFriendsPermission}
                variant={"contained"}
                style={{
                  display: "table",
                  margin: "0 auto",
                  marginBottom: bottomMargin,
                  width: buttonWidth,
                  textTransform: "none",
                  backgroundColor: "#1877f2",
                  color: "white"
                }}>
          Grant Permission
          </Button>
        )
    } else {
      // User is not logged in, this should be a login button
      facebookButton = (
        <input type={"image"}
               src={FACEBOOK_LOGIN_BUTTON_IMAGE_URL}
               style={{width: buttonWidth, cursor: "pointer", marginBottom: bottomMargin}}
               onClick={this.loginFacebook}/>
      )
    }
    return facebookButton
  }

  ComingSoon() {
    return (
      <div className={"text-center"}>
        <h3>Coming Soon!</h3>
        <p>The Cook'n programmers are working with Facebook to get this feature up and running.</p>
      </div>
    )
  }
}


export default InviteFromFacebook



// WEBPACK FOOTER //
// ./src/Components/InviteFromFacebook.js